module.exports = __webpack_public_path__ + "static/img/アセット 61@3x.b89da74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 61@3x.png
// module id = 6VDg
// module chunks = 1